var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedprofile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_3930)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5351 58.0375L44.548 57.0752L44.5479 57.0749L45.5351 58.0375Z",
    fill: "#377DE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4819_3930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2878 47.4495L32.8607 44.5234C30.4865 42.4976 31.8 38.6018 34.9157 38.4215L39.1584 38.181C40.7 33.9799 40.8789 32.3057 43.2068 31.7645V21.2396C43.2083 18.9009 41.3075 17 38.9687 17H21.2396C18.9009 17 17 18.9009 17 21.2396V45.1354C17 47.4741 18.9009 49.375 21.2396 49.375H35.8006L36.2878 47.4495Z",
    fill: "url(#paint1_linear_4819_3930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1038 27.7917C31.8067 27.7917 33.1872 26.4112 33.1872 24.7083C33.1872 23.0055 31.8067 21.625 30.1038 21.625C28.401 21.625 27.0205 23.0055 27.0205 24.7083C27.0205 26.4112 28.401 27.7917 30.1038 27.7917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1146 35.5H25.0937C24.4555 35.5 23.9375 34.982 23.9375 34.3437V33.5729C23.9375 31.2342 25.8384 29.3333 28.1771 29.3333H32.0312C34.37 29.3333 36.2708 31.2342 36.2708 33.5729V34.3437C36.2708 34.982 35.7528 35.5 35.1146 35.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.808 53.7996L43.9795 50.5143L39.151 53.7996C38.266 54.3978 37.1206 53.5822 37.3796 52.5601L38.8827 46.6247L34.3625 42.7659C33.5732 42.0922 34.008 40.791 35.0486 40.7324L40.8067 40.4071L42.8941 34.7184C43.2641 33.7117 44.6963 33.7117 45.0648 34.7184L47.1522 40.4071L52.9103 40.7324C53.9509 40.7925 54.3857 42.0937 53.5964 42.7659L49.0762 46.6247L50.5793 52.5601C50.843 53.5976 49.679 54.39 48.808 53.7996Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0141 40.125H24.7087C23.8577 40.125 23.167 39.4343 23.167 38.5833C23.167 37.7323 23.8577 37.0417 24.7087 37.0417H31.0141C31.8651 37.0417 32.5557 37.7323 32.5557 38.5833C32.5557 39.4343 31.8651 40.125 31.0141 40.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 44.75H24.7087C23.8577 44.75 23.167 44.0593 23.167 43.2083C23.167 42.3573 23.8577 41.6667 24.7087 41.6667H29.3337C30.1847 41.6667 30.8753 42.3573 30.8753 43.2083C30.8753 44.0593 30.1847 44.75 29.3337 44.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_3930",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4819_3930",
    x1: 30.1034,
    y1: 17,
    x2: 30.1034,
    y2: 49.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4819_3930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedprofile);
export default __webpack_public_path__ + "static/media/FEATUREDPROFILE.c713f794dc980d1e5230b47bb17e0cfd.svg";
export { ForwardRef as ReactComponent };